import { useMaximumBenefit } from './useMaximumBenefit';

export function usePdpUserAccountBenefitInfo() {
  const DEFAULT_DATA = {
    pdp_user_account_mileage: { available_mileage: 0 },
    pdp_user_account_point: { available_point: 0 },
  };
  const { pdp_user_base_info, ...response } = useMaximumBenefit();

  return {
    ...response,
    pdp_user_base_info: response.error || !pdp_user_base_info ? DEFAULT_DATA : pdp_user_base_info,
  };
}
